import React, { useState, useEffect } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import {
  DataGrid,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarColumnsButton,
} from "@mui/x-data-grid";
// import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/api/api";
import CustomNoRowsOverlay from "../../components/NoRows";
import OutbondDetails from "./_components/OutbondDetails";
import moment from "moment";
import toast, { Toaster } from "react-hot-toast";
import successSound from "../../assets/audio/success.mp3";
import errorSound from "../../assets/audio/error.mp3";

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
    </GridToolbarContainer>
  );
}

const columns = [
  {
    field: "date",
    headerClassName: "header",
    headerName: "Date",
    width: 150,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {moment(value).format("DD/MM/YYYY")}
      </Typography>
    ),
  },
  {
    field: "customer_name",
    headerClassName: "header",
    headerName: "Customer",
    width: 150,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "code_production",
    headerClassName: "header",
    headerName: "Production Code",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "code_recipe",
    headerClassName: "header",
    headerName: "Recipe Code",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "fabric_weight",
    headerClassName: "header",
    headerName: "Fabric Weight (kg)",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "color",
    headerClassName: "header",
    headerName: "Color",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "chemical_name",
    headerClassName: "header",
    headerName: "Chemical Name",
    width: 100,
    flex: 2,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "weight_kg",
    headerClassName: "header",
    headerName: "Weight (kg)",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {parseFloat(value).toLocaleString("id-ID", {
          maximumFractionDigits: 1,
        })}
      </Typography>
    ),
  },
  {
    field: "weight_gram",
    headerClassName: "header",
    headerName: "Weight (gr)",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {parseInt(value).toLocaleString(["ban", "id"])}
      </Typography>
    ),
  },
];

const OutbondList = () => {
  const [pageSize, setPageSize] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [outbondItem, setOutbondItem] = useState({});
  const [outboundData, setOutboundData] = useState([]);
  // const user = JSON.parse(localStorage.getItem("admin_data"));
  const token = JSON.parse(localStorage.getItem("userToken"));
  const authentication = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [cleanStartDate, setCleanStartDate] = useState("");
  const [cleanEndDate, setCleanEndDate] = useState("");
  const todayDate = new Date();
  const formatDate = moment(todayDate).format("DD/MM/YYYY");
  const limit = moment(todayDate).add(0, "days");
  const formattedLimit = moment(limit).format("YYYY-MM-DD");
  const successEffect = new Audio(successSound);
  const errorEffect = new Audio(errorSound);

  // const onDetail = (dt) => {
  //   setOutbondItem(dt);
  //   setModalOpen(true);
  // };

  const fnEnd = (e) => {
    setEndDate(moment(e).format("DD/MM/YYYY"));
    setCleanEndDate(moment(e).format("L"));
  };

  const fnStart = (e) => {
    setStartDate(moment(e).format("DD/MM/YYYY"));
    setCleanStartDate(moment(e).format("L"));
  };

  const getDataByPeriod = async () => {
    await axiosInstance
      .get(
        `/api/outbounds?start_date=${startDate}&finish_date=${endDate}`,
        authentication,
      )
      .then((res) => {
        // console.log(res.data);
        if (res?.data.length === 0) {
          errorEffect.play();
          toast.error("No data found");
        } else {
          successEffect.play();
          toast.success(`${res?.data?.length} data found`);
        }
        setOutboundData(res.data);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Oops! Something is wrong. Please try again.");
      });
  };

  const getOutbounds = async () => {
    await axiosInstance
      // .get("/api/outbounds/", authentication)
      .get(
        `/api/outbounds?start_date=${formatDate}&finish_date=${formatDate}`,
        authentication,
      )
      .then((res) => {
        // console.log(res.data);
        setOutboundData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getOutbounds();
  }, []);

  return (
    <Box flex="1" sx={{ backgroundColor: "#f6f6f6" }}>
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          className: "",
          duration: 3000,
          style: {
            background: "#FFF",
            color: "#222",
          },
          success: {
            duration: 3000,
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
        }}
      />
      <OutbondDetails
        open={modalOpen}
        setModalOpen={setModalOpen}
        data={outbondItem}
      />
      <Stack
        direction="row"
        justifyContent="space-between"
        paddingX={3}
        sx={{ backgroundColor: "#F6F6F6" }}
        paddingY={2}
      >
        <Typography variant="h4" fontWeight="500">
          Outbounds
        </Typography>
      </Stack>
      <Stack
        paddingX={3}
        gap={2}
        direction={"row"}
        justifyContent={"flex-start"}
      >
        <Stack gap={1}>
          <Typography fontSize={14}>Start date</Typography>
          <Stack sx={{ backgroundColor: "#FFF", width: "full" }}>
            <input
              name="date"
              type="date"
              onChange={(e) => fnStart(e.target.value)}
              style={{
                backgroundColor: "#FFF",
                height: "28px",
                width: "150px",
                fontFamily: "Inter",
                fontSize: "16px",
                border: "1px solid #c8c8c8",
                borderRadius: "5px",
                padding: "5px 12px",
              }}
              max={formattedLimit}
            />
          </Stack>
        </Stack>
        <Stack gap={1}>
          <Typography fontSize={14}>End date</Typography>
          <Stack sx={{ backgroundColor: "#FFFF" }}>
            <input
              name="date"
              type="date"
              onChange={(e) => fnEnd(e.target.value)}
              style={{
                backgroundColor: "#FFF",
                height: "28px",
                width: "150px",
                fontFamily: "Inter",
                fontSize: "16px",
                border: "1px solid #c8c8c8",
                borderRadius: "5px",
                padding: "5px 12px",
              }}
              max={formattedLimit}
            />
          </Stack>
        </Stack>
        <Button
          sx={{
            textTransform: "capitalize",
            borderRadius: "11px",
            backgroundColor: "#222",
            height: "40px",
            color: "#FFF",
            bottom: 0,
            marginTop: "28px",
            ":hover": {
              backgroundColor: "#444",
              color: "#FFF",
            },
          }}
          variant="contained"
          disabled={startDate === "" || endDate === "" ? true : false}
          onClick={() => getDataByPeriod()}
        >
          Get Data
        </Button>
      </Stack>

      <Stack>
        <Box
          sx={{
            "& .header": {
              backgroundColor: "#FFF",
              color: "#222",
            },
            "& .header-font": {
              backgroundColor: "#F6F6F6",
              color: "#F6F6F6",
            },
            padding: 3,
          }}
        >
          <DataGrid
            rows={outboundData}
            columns={columns}
            pageSize={pageSize}
            autoHeight
            getRowId={(rows) => rows._id}
            header
            pagination
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[10, 15, 25]}
            components={{
              Toolbar: CustomToolbar,
              NoRowsOverlay: CustomNoRowsOverlay,
            }}
            // onRowClick={(rows) => onDetail(rows.row)}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              border: "none",
              color: "#535252",
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default OutbondList;
